<template>
  <div class="fp">
    <div class="head-nav d-aligncnter">
      <div class="nav-left d-allcenter" @click="pageToBack">
        <img src="@/assets/img/appointment/back.svg" />
      </div>
      <div class="nav-title d-allcenter overflow">发票设置</div>
      <div class="nav-right d-allcenter" style="font-size: 12px"></div>
    </div>
    <div class="content">
      <div style="height: 200px">
        <div class="each d-aligncnter">
          <div>公司抬头</div>
          <div class="ml-16">
            <input v-model="invoiceInfo.companyTitle" placeholder="请填写单位名称" class="myinput" />
          </div>
        </div>
        <div class="each d-aligncnter">
          <div>公司税号</div>
          <div class="ml-16">
            <input v-model="invoiceInfo.dutyParagraph" placeholder="请填写纳税人识别号" class="myinput" />
          </div>
        </div>

        <div class="each d-aligncnter">
          <div>电子邮箱</div>
          <div class="ml-16">
            <input v-model="invoiceInfo.email" placeholder="请填写电子邮箱" class="myinput" />
          </div>
        </div>
      </div>
      <div style="width: 100%; height: calc(100vh - 450px); min-height: 32px"></div>
      <div class="d-allcenter">
        <button class="save-btn" style="width: 104px" @click="saveInvoice">保存</button>
      </div>
      <div class="fs-sm grey" style="width: calc(100vw - 64px); margin-left: 32px; margin-top: 16px">
        为方便您开票，您的发票抬头信息将用于校外场馆预约业务。设置完成后订单开票可快捷读取数据，发票将发送到您的电子邮箱里。
      </div>
    </div>
  </div>
</template>
<script>
import { Message } from 'element-ui'
import { getInvoiceTemplate, saveInvoiceTemplate } from '@/api/api-venueOrder'
export default {
  data() {
    return {
      phone: '',
      invoiceInfo: { companyTitle: '', dutyParagraph: '', email: '' },
      rightText: '编辑',
      radio: 0,
      value: 0,
      needFp: 0,
    }
  },
  mounted() {
    // let _this = this
    // document.getElementById('percent').addEventListener('input', function () {
    //   _this.update(Number(this.value))
    // })
    // this.autoplay()
    this.getInvoiceData()
  },
  computed: {
    visibleAreaHeight() {
      if (window.innerHeight > 400) {
        return 'ifMt'
      } else {
        return 'mt-16'
      }
    },
  },
  methods: {
    pageToBack() {
      this.$router.go(-1)
    },
    getInvoiceData() {
      const userId = localStorage.getItem('userId')
      getInvoiceTemplate(userId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getUser:', res)
          this.invoiceInfo = res.data.obj
        }
      })
    },
    saveInvoice() {
      const userId = localStorage.getItem('userId')
      saveInvoiceTemplate(
        userId,
        this.invoiceInfo.companyTitle,
        this.invoiceInfo.dutyParagraph,
        this.invoiceInfo.email
      ).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getUser:', res)
          Message.success('保存成功')
        } else {
          Message.error(res.data.message)
        }
      })
    },
    update(percent) {
      console.log('update:', percent)
      const circle = document.getElementById('circle')
      const length = Math.PI * Number(circle.getAttribute('r')) * 2
      const dash = [length * percent * 0.8, length].join(' ')
      circle.setAttribute('stroke-dasharray', dash)
    },

    trigger(value) {
      console.log('trigger:', value)
      const el = document.getElementById('percent')
      el.value = value
      const event = new Event('input')
      //   event.target = el
      el.dispatchEvent(event)
    },

    async autoplay() {
      const timer = setInterval(() => {
        if (this.value > 1) return clearInterval(timer)
        this.trigger((this.value += 0.01))
      }, 16)
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';

.mt-16 {
  margin-top: 16px;
}
.content {
  padding: 0;
  font-size: 14px;
  background: #f9f9f9;
  height: calc(100vh - 44px);
  overflow: scroll;
}
.each {
  background: #f9f9f9;
  box-shadow: 0px -1px 0px 0px #e8e8e8 inset;
  padding: 8px 16px;
  min-height: 32px;
  color: #181818;
}
.photo {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #d4a3fc;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
.save-btn {
  border-radius: 52px;
  background: linear-gradient(270deg, #2f2f2f 0%, #464646 100%);
  width: 343px;
  height: 42px;
  border: none;
  color: #fff;
  font-size: 14px;
  margin-top: 16px;
  //   position: absolute;
  //   bottom: 152px;
}
.ml-16 {
  margin-left: 16px;
}
.test {
  //   * {
  //     box-sizing: border-box;
  //     margin: 0;
  //     padding: 0;
  //   }

  .box {
    height: 200px;
    width: 200px;
    position: relative;
  }

  .box:before {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    top: 0;
    left: 0;

    transform: rotate(90deg);

    background-image: conic-gradient(
      from 90deg,
      rgba(111, 232, 191, 1),
      rgba(255, 175, 19, 1),
      rgba(222, 19, 80, 1),
      rgba(133, 14, 205, 1)
    );
    mask-image: url(#ring);
    -webkit-mask-image: url(#ring);
    mask-size: cover;
    mask-repeat: no-repeat;
  }
}
.ifMt {
  margin-top: calc(100vh - 400px);
}
.mt-16 {
  margin-top: 16px;
}
.myinput {
  border: none;
  outline: none;
  height: 40px;
  width: calc(100vw - 160px);
  background-color: #f9f9f9;
}
.fp ::v-deep .el-radio__input.is-checked .el-radio__inner {
  border-color: #1a875f;
  background: #1a875f;
}
.fp ::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #2f2f2f;
}
.fp ::v-deep .el-radio {
  color: #2f2f2f;
}
.fp ::v-deep .el-radio__inner {
  width: 18px;
  height: 18px;
}
</style>
